import {
  QueryKey,
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import Axios from './../../apiConfig/Axios';
import apiRoutes from 'services/apiRoutes';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

let countRefreshCaptcha = 0;
const numberRevalidate = 16;
const longRevalidate = 1.9 * 60 * 1000;

const isEnableInterval = () => {
  if (countRefreshCaptcha < numberRevalidate) {
    return true;
  }

  return false;
};

//////////////////////////////////////captch//////////////////////////
const fetchCaptchFn = async () => {
  countRefreshCaptcha++;
  const res = await Axios.get<resCaptchaType>(apiRoutes.captch.Get);
  return res.data;
};

export const useGetCaptch = () => {
  const { t } = useTranslation();
  let getSessionCaptcha = sessionStorage.getItem('isInvalidCaptcha');

  return useQuery<resCaptchaType, Error>(['Captcha'], fetchCaptchFn, {
    refetchInterval: isEnableInterval() ? longRevalidate : false,
    onSuccess: (data) => {
      if (getSessionCaptcha) {
        countRefreshCaptcha = 0;
        sessionStorage.removeItem('isInvalidCaptcha');
      }
      if (countRefreshCaptcha >= numberRevalidate) {
        sessionStorage.setItem('isInvalidCaptcha', 'true');
        toast.warning('کد امنیتی منقضی شده است، لطفا مجدد تلاش کنید');
      }
      if (data.result === 'TooRequest') {
        toast.error(t(`BlockByCaptcha.BlockByCaptcha`));
      }
    },
    refetchOnReconnect: true,
  });
};

//////////////////////////////////////Index//////////////////////////
const fetchIndexFn = async () => {
  const res = await Axios.get<GlobalApiResponseType<resIndexType>>(
    apiRoutes.Index.Get
  );
  return res.data;
};

export const useGetIndex = () => {
  return useQuery<GlobalApiResponseType<resIndexType>>(
    ['index'],
    fetchIndexFn,
    {
      refetchOnMount: false,
    }
  );
};

//////////////////////////////////////useMutation Authorization//////////////////////////
const fetchAuthorizationFn = async (data: reqAuthorizationType) => {
  const res = await Axios.post<
    GlobalApiResponseType<responseAuthorizationType>
  >(apiRoutes.Authorization.Post, data);
  return res.data;
};

export const useAuthorization = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<responseAuthorizationType>,
      Error,
      reqAuthorizationType
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    GlobalApiResponseType<responseAuthorizationType>,
    Error,
    reqAuthorizationType
  >(fetchAuthorizationFn, option);
};

//////////////////////////////////////useQuery Authorization//////////////////////////
const fetchAuthorizationQueryFn = async (data: any) => {
  const res = await Axios.post<
    GlobalApiResponseType<responseAuthorizationType>
  >(apiRoutes.Authorization.Post, data);
  return res.data;
};

export const useAuthorizationQuery = (
  data: any,
  options?:
    | Omit<
        UseQueryOptions<
          GlobalApiResponseType<responseAuthorizationType>,
          unknown,
          GlobalApiResponseType<responseAuthorizationType>,
          QueryKey
        >,
        'mutationKey' | 'mutationFn'
      >
    | undefined
) => {
  return useQuery(
    ['autorization'],
    () => fetchAuthorizationQueryFn(data),
    options
  );
};

//////////////////////////////////////fetchTwoFactorAuthorizationFn//////////////////////////
const fetchTwoFactorAuthorizationFn = async (data: reqTwoFactorType) => {
  const res = await Axios.post<
    GlobalApiResponseType<responseAuthorizationType>
  >(apiRoutes.twoFactor.Post, data);
  return res.data;
};

export const useTwoFactorAuthorization = (
  option?: Omit<
    UseMutationOptions<
      GlobalApiResponseType<responseAuthorizationType>,
      Error,
      reqTwoFactorType
    >,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<
    GlobalApiResponseType<responseAuthorizationType>,
    Error,
    reqTwoFactorType
  >(fetchTwoFactorAuthorizationFn, option);
};
//////////////////////////////////////retrySms//////////////////////////
const fetchRetrySmsFn = async (data: reqRetrySmsType) => {
  const res = await Axios.post<GlobalApiResponseType<any>>(
    apiRoutes.retrySms.Post,
    data
  );
  return res.data;
};

export const useRetrySms = (
  option?: Omit<
    UseMutationOptions<GlobalApiResponseType<any>, Error, reqRetrySmsType>,
    'mutationKey' | 'mutationFn'
  >
) => {
  return useMutation<GlobalApiResponseType<any>, Error, reqRetrySmsType>(
    fetchRetrySmsFn,
    option
  );
};

///////////////////////////////////resource////////////////////////////

// const fetchResource = async () => {
//   const res = await Axios.get<any>(apiRoutes.Resource.Get);
//   return res.data;
// };
//
// export const useGetResource = () => {
//   return useQuery<any>(['resource'], fetchResource, {
//     refetchOnMount: false,
//   });
// };
